export default {

  General_information: ' Información general',
  Services: '  Servicios',
  ALL_SERVICES: 'TODOS LOS SERVICIOS'


}